import {
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  FormFeedback,
  Label,
} from 'reactstrap';
import {
  Controller,
  Control,
  FieldValues,
  UseFormReturn,
} from 'react-hook-form';
import './PhoneInput.scss';
import { useTranslation } from 'react-i18next';
import React, { ChangeEvent, useState } from 'react';

interface PropsTypes {
  label: string;
  rules?: object;
  placeholder: any;
  controlName: string;
  form: UseFormReturn;
  control: Control<FieldValues, object>;
  required?: boolean;
  disabled?: boolean;
}

interface Country {
  name: string;
  code: string;
  iso: string;
  rules: {
    pattern: {
      value: RegExp;
      message: string;
    };
  };
}

const PhoneInput = (props: PropsTypes) => {
  const { t } = useTranslation();
  const countries: Country[] = [
    {
      name: 'Israel',
      iso: 'ILS',
      code: '972',
      rules: {
        pattern: {
          value: /^[\+](972)[-]?[1-9]{1}[0-9]{1}?[-]?[0-9]{6,7}$/i,
          message: t('FORM_ERRORS_INVALID_PHONE'),
        },
      },
    },
    {
      name: 'United states',
      iso: 'USA',
      code: '1',
      rules: {
        pattern: {
          value: /^[\+](1)[-]?[1-9]{1}[0-9]{1}[-]?[0-9]{7}$/i,
          message: t('FORM_ERRORS_INVALID_PHONE'),
        },
      },
    },
  ];

  const [isDropDownOpen, setIsDropdownOpen] = useState<boolean>(false);

  const [chosenCountry, setChosenCountry] = useState<Country>(countries[0]);

  const errors = props.form.formState.errors;

  const phoneNumberHandler = (phoneNumber: string): string => {
    phoneNumber = phoneNumber.replaceAll('-', '');

    if (phoneNumber[0] === '0') {
      return `${phoneNumber.slice(1, phoneNumber.length)}`;
    }

    if (phoneNumber.startsWith(chosenCountry.code)) {
      return `${phoneNumber.slice(
        chosenCountry.code.length,
        phoneNumber.length
      )}`;
    }

    return `${phoneNumber}`;
  };
  const toggle = () => setIsDropdownOpen((prevState) => !prevState);

  const setVal = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value.toString();

    const value = `+${chosenCountry.code}${phoneNumberHandler(inputValue)}`;

    const regex = chosenCountry.rules.pattern.value;

    if (regex.test(inputValue)) {
      return true;
    }

    if (inputValue.length) {
      props.form.setValue(props.controlName, value);
    } else {
      props.form.setValue(props.controlName, '');
    }
  };

  return (
    <>
      <Label for={props.label}>
        {props.required && <span className="required-span">* </span>}
        {t(props.placeholder)}
      </Label>
      <Controller
        rules={chosenCountry.rules}
        name={props.controlName}
        control={props.control}
        render={({ field }) => {
          const defaultValue = field.value?.toString()
            ? +field.value
                .toString()
                .slice(chosenCountry.code.length + 1, field.value.length)
            : field.value;

          return (
            <InputGroup className={'phone-input-group-rtl'}>
              <Dropdown isOpen={isDropDownOpen} toggle={toggle}>
                <DropdownToggle caret disabled className={'phone-button-rtl'}>
                  {chosenCountry.iso} ({chosenCountry.code})
                </DropdownToggle>
                <DropdownMenu>
                  {countries.map((country: Country) => (
                    <DropdownItem
                      onClick={() => setChosenCountry(country)}
                      key={country.name}
                    >
                      {country.name}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              <Input
                onChange={(event) => setVal(event)}
                type="text"
                required={props.required}
                placeholder={t(props.placeholder)}
                autoComplete="false"
                invalid={errors?.[props.controlName] && true}
                defaultValue={defaultValue}
                className={'phone-input-rtl'}
                disabled={props.disabled}
              />
              {errors?.[props.controlName] ? (
                <FormFeedback className="form-input-error phone-input-error-rtl">
                  {errors.phone.message}
                </FormFeedback>
              ) : null}
            </InputGroup>
          );
        }}
      />
    </>
  );
};

export default PhoneInput;
